import { EmployeesService, DeclarationService, MasterdataAService } from "../../services/index";
import { HourCodeService } from "../../services/hourCode.service";

export const timesheetsState: aboTheme.IState = {
    parent: "app",
    name: "timesheets",
    url: "/timesheets",
    redirectTo: "timesheets.dashboard",
    component: "timesheetsComponent",
    data: {
        permissions: {
            only: ['TIMESHEETS'],
            redirectTo: 'schedule'
        }
    }
};

export const timesheetsDashboardState: aboTheme.IState = {

    name: "timesheets.dashboard",
    url: "/dashboard",
    resolve: {
        employees: (EmployeesService: EmployeesService, $stateParams: ng.ui.IStateParamsService) => {
            "ngInject";
            var moment = require('moment');

            var startDate = moment().startOf('isoweek').toDate();
            var endDate = moment().endOf('isoweek').toDate();

            return EmployeesService.customAll('employeeSummary', { from: startDate, till: endDate });
        }
    },
    views: {
        "main": 'timesheetsDashboardComponent'
    }
};

export const timesheetsOverviewState: aboTheme.IState = {

    name: "timesheets.overview",
    url: "/overview?employeeId",
    resolve: {
    },
    views: {
        "main": 'timesheetsOverviewComponent'
    },
    data: {
        permissions: {
            only: ['FINANCE'],
            redirectTo: 'timesheets'
        }
    }
};

export const timesheetsDeclarationState: aboTheme.IState = {

    name: "timesheets.dashboard.declaration",
    url: "/declaration/:declarationId?employeeId&shiftId&type&shiftStartDate&shiftEndDate",
    params: {
        employeeId: null,
        shiftId: null,
        type: null,
        shiftStartDate: null,
        shiftEndDate: null
    },
    modal: true,
    resolve: {
        wageCodes: (HourCodeService: HourCodeService) => { 
            "ngInject"; 
            // Haal alleen looncomponent hourcodes op (type = 0)
            return HourCodeService.getByType(0); 
        },
        declaration: (DeclarationService: DeclarationService, $stateParams: ng.ui.IStateParamsService) => {
            "ngInject";
            if ($stateParams['declarationId']) {
                return DeclarationService.get($stateParams['declarationId']);
            }
        },
        employee: (EmployeesService: EmployeesService, $stateParams: ng.ui.IStateParamsService) => {
            "ngInject";
            if ($stateParams['employeeId']) {
                return EmployeesService.get($stateParams['employeeId']);
            }
        }
    },
    component: 'declarationComponent'
};


// WEBPACK FOOTER //
// ./src/app/modules/timesheets/timesheets.states.ts